/**
 * Base publique du monolithe Klub (images /uploads/…).
 * Les appels métier magazine passent par outil_gestion_abonnements_api
 * (/api/klub/magazine/… → proxy klub_api), pas directement ici.
 */
export function getKlubPublicBaseUrl() {
  const raw = process.env.REACT_APP_KLUB_PUBLIC_URL || 'https://klub.koikispass.com';
  return raw.replace(/\/+$/, '');
}

/**
 * Transforme un chemin média stocké en BDD (souvent encodé) en URL absolue.
 */
export function resolveKlubMediaUrl(path) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  const trimmed = path.trim();
  if (!trimmed) {
    return null;
  }

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  let decoded = trimmed;
  try {
    decoded = decodeURIComponent(trimmed);
  } catch {
    // chemin déjà décodé ou mal formé : on garde tel quel
  }

  const normalized = decoded.startsWith('/') ? decoded : `/${decoded}`;
  return `${getKlubPublicBaseUrl()}${normalized}`;
}
